import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Client } from '@classes/client';
import { ClientStatisticsByMonth } from '@classes/client-statistics/client-statistics-by-month';
import { ClientStatisticsByMonthRequest } from '@classes/client-statistics/client-statistics-by-month-request';
import { ClientStatisticsByYear } from '@classes/client-statistics/client-statistics-by-year';
import { ClientStatisticsByYearRequest } from '@classes/client-statistics/client-statistics-by-year-request';
import { ClientStatisticsService } from '@services/client-statistics.service';
import { Observable, forkJoin } from 'rxjs';

@Component({
  selector: 'app-crm',
  templateUrl: './crm.component.html',
  styleUrls: ['./crm.component.scss']
})
export class CRMComponent implements OnInit {
  // State
  public isLoading: boolean = false;
  public clientStatisticsByMonth: ClientStatisticsByMonth = null;
  public clientStatisticsByYear: ClientStatisticsByYear[] = [];

  // Filter data
  public clients: Client[] = [];

  public filterForm = this._fb.group({
    client: [null, [Validators.required]],
    startDate: [null, [Validators.required]],
    endDate: [null, [Validators.required]],
  });

  constructor(
    private _route: ActivatedRoute,
    private _fb: FormBuilder,
    private _clientStatisticsSrv: ClientStatisticsService,
  ) { }

  public ngOnInit(): void {
    this._getClientsFormRoute();
  }

  private _getClientsFormRoute(): void {
    this._route.data
      .subscribe((datas: { clients: Client[] }) => {
        this.clients = datas.clients;
      });
  }

  public onResetFilterForm(): void {
    this.filterForm.reset();
    this.clientStatisticsByMonth = null;
  }

  public onSubmitFilterForm(): void {
    this.isLoading = true;

    forkJoin({
      clientStatisticsByMonth: this._fetchMonthStatistics$(),
      clientStatisticsByYear: this._fetchYearStatistics$(),
    }).subscribe({
      next: ({ clientStatisticsByMonth, clientStatisticsByYear }) => {
        this.clientStatisticsByMonth = clientStatisticsByMonth;
        this.clientStatisticsByYear = clientStatisticsByYear.sort((a, b) => a.year - b.year);
        this.isLoading = false;
      },
      error: () => {
        this.clientStatisticsByMonth = null;
        this.clientStatisticsByYear = [];
        this.isLoading = false;
      }
    });
  }

  private _fetchMonthStatistics$(): Observable<ClientStatisticsByMonth> {
    const request = this._buildMonthStatisticsRequest();
    return this._clientStatisticsSrv.getByMonth$(request);
  }

  private _buildMonthStatisticsRequest(): ClientStatisticsByMonthRequest {
    const client: Client = this.filterForm.get('client').value;
    const startDate: Date = this.filterForm.get('startDate').value;
    const endDate: Date = this.filterForm.get('endDate').value;

    return new ClientStatisticsByMonthRequest(client.id, startDate, endDate);
  }

  private _fetchYearStatistics$(): Observable<ClientStatisticsByYear[]> {
    const request = this._buildYearStatisticsRequest();
    return this._clientStatisticsSrv.getByYear$(request);
  }

  private _buildYearStatisticsRequest(): ClientStatisticsByYearRequest {
    const client: Client = this.filterForm.get('client').value;
    const startDate: Date = new Date(this.filterForm.get('startDate').value);
    const endDate: Date = new Date(this.filterForm.get('endDate').value);
    const startYear: number = startDate.getFullYear();
    const endYear: number = endDate.getFullYear();

    return new ClientStatisticsByYearRequest(client.id, startYear, endYear);
  }
}